import O1HD from "../../../../engines/gameEngine";
import { getOneNormalEventNewById } from "../../config/normalEvent_NewConfig";
import { AccountItem, NormalEventChoose_New, NormalEventChoose_NewParam, NormalEvent_New } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import normalMode from "../../normalMode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class normalEventNewBase extends cc.Component {

    @property({type:cc.Node,displayName:"中心节点"})
    centerNode:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lb_Dec:cc.Label = null;

    @property({type:cc.Node,displayName:"小头像节点"})
    headSp:cc.Node = null;

    @property({type:cc.Node,displayName:"选择节点"})
    chooseNode:cc.Node = null;

    @property({type:cc.Node,displayName:"图片显示节点"})
    spNode:cc.Node = null;

    eventData:NormalEvent_New = null;

    isStart:boolean = true;

    startData:NormalEvent_New = <NormalEvent_New>{};

    gameLayer:normalMode = null;

    complete ?: ()=>void;
    
    start(){

    }

    bindEvent(id:string | number,gameLayer:normalMode,complete?:()=>void){
        this.eventData = <NormalEvent_New>{}
        let event = getOneNormalEventNewById(id);
        for(let k in event){
            let data = event[k];
            if(data instanceof Array){
                this.eventData[k] = data.concat();
                if(this.isStart){
                    this.startData[k] = data.concat();
                }
            }else{
                this.eventData[k] = data;
                if(this.isStart){
                    this.startData[k] = data;
                }
            }
        }
        if(this.isStart){
            this.isStart = false;
        }
        this.gameLayer = gameLayer;
        this.complete = complete;
        this.loadEvent();
    }

    loadEvent(){}
    async updateChoose(){
        this.chooseNode.children.forEach((n:cc.Node)=>{
            n.active = false;
        });
        let chooseData:NormalEventChoose_New[] = this.eventData.eventChooses;
        let dec:string = this.eventData.eventExplain;
        for(let i =0;i<dec.length;i++){
            let s = dec[i];
            this.lb_Dec.string += s;
            await new Promise<void>(resolve=>{
                this.scheduleOnce(resolve,.02);
            });
        }

        if(chooseData){
            for(let i = 0;i<chooseData.length;i++){
                let node:cc.Node = this.chooseNode.children[i];
                node.active = true;
                node.getChildByName("lbName").getComponent(cc.Label).string = this.eventData.eventChooses[i].chooseExplain;
            }
        }else{
            this.eventData.eventChooses = [
                {chooseExplain:"知道了"}
            ];
            let chooseNode:cc.Node = this.chooseNode.children[0];
            chooseNode.active = true;
            chooseNode.getChildByName("lbName").getComponent(cc.Label).string = this.eventData.eventChooses[0].chooseExplain;
        }
    }

    onBtnChoose(e:cc.Event.EventTouch,cum){
        let index:number = Number(cum);
        let targetNode:cc.Node = e.target;
        this.chooseNode.children.forEach((n:cc.Node)=>{
            n.active = false;
        });
        let pFun = () =>{
            let parms :NormalEventChoose_NewParam = this.eventData.eventChooses[index].param;
            // console.log("222222>>>>>>>>>>",index,parms)
            if(parms){
                let addCoin:number = parms["coin"];
                if(addCoin!=null){
                    if(addCoin == 0){
                        let coin:number = O1HD.getServices().userSrv.getCoins() * 0.3;
                        O1HD.getServices().userSrv.setCoins(-coin,true);
                    }else{
                        O1HD.getServices().userSrv.setCoins(addCoin,true,targetNode);
                    }
                }

                let linkId = parms["WeChatLink"];
                if(linkId!=null){
                    if(linkId instanceof Array){
                        for(let i = 0;i<linkId.length;i++){
                            this.gameLayer.gameManager.addOneWeChatTriggerLink(linkId[i]);
                        }
                    }else{
                        this.gameLayer.gameManager.addOneWeChatTriggerLink(linkId);
                    }
                }
                let add:string = parms["addEvent"];
                if(add!=null){
                    this.gameLayer.gameManager.getGameData().ariseEvent.push(this.startData.id);
                    this.gameLayer.gameManager.writeGameData();
                }

                let acCountInfo:{title:string,desc:string,paramsArray:string[],totalFee:number,needPayDays:number}= parms["accountInfo"];
                if(acCountInfo){
                    let accountItem:AccountItem = {
                        uniqueId:NormalGameManager._instance.getGameData().userAccountInfo.length.toString(),
                        title : acCountInfo.title,
                        desc : acCountInfo.desc,
                        paramsArray:acCountInfo.paramsArray,
                        totalFee : acCountInfo.totalFee,
                        needPayDays : acCountInfo.needPayDays,
                        hasPayDays : 0,
                        everyDayPay: Math.floor(acCountInfo.totalFee / acCountInfo.needPayDays),
                    }
                    NormalGameManager._instance.setGameData({ userAccountInfo:[accountItem] },true );
                    NormalGameManager._instance.setGameData({ userAccountInfoNewMsg : 1 } , false );
                }

                let nextId:string = parms["nextId"];
                console.log(nextId,"nextIdddd")
                if(nextId != null){
                    this.bindEvent(nextId,this.gameLayer,this.complete); 
                }else{
                    if(this.gameLayer.gameManager.getNodeStr().length < 1){
                        this.gameLayer.gameManager.openOneNewEvent();
                    }else{
                        this.gameLayer.canShowFlag = true;
                    }
                    this.node.destroy();
                    this.node.removeFromParent();
                    console.log("关闭!!!!");
                }
            }else{
                // O1HD.emit("GarbagePrefabNode.resumeCutDown");
                if(this.gameLayer.gameManager.getNodeStr().length < 1){
                    this.gameLayer.gameManager.openOneNewEvent();
                }else{
                    this.gameLayer.canShowFlag = true;
                }
                this.node.destroy();
                this.node.removeFromParent();
                console.log("关闭!!!!");
            }
        }

        this.closeThis(()=>{
            pFun();
        });
    }

    closeThis(complete?:()=>void){
        complete && complete();
    }

    update(dt: number): void {
        NormalGameManager._instance.pauseTimer();    
    }

    onDisable(): void {
        NormalGameManager._instance.resumeTimer();    
    }
}
